var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      pad: "0",
      widthClass: "max-1000",
      title: _vm.$t("label_essweb_RosterTemplate_form_newTitle"),
      initData: _vm.RosterTemplateData,
      backgroundClass: "white",
      checkData: [
        "roster_weekly_template_name",
        "roster_weekly_template_code",
        "std_work_integer",
        "std_work_text",
        "start_utc_datetime",
        "roster_weekly_template_description",
        "is_default",
        "remarks",
      ],
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Stepper", {
              attrs: { curStep: _vm.curStep, items: _vm.stepper },
              scopedSlots: _vm._u([
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c(
                        "v-form",
                        { ref: "form", attrs: { "lazy-validation": "" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "8",
                                    lg: "8",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      bindData:
                                        _vm.RosterTemplateData
                                          .roster_weekly_template_name,
                                      maxlength: "100",
                                      label: _vm.$t(
                                        "label_essweb_RosterTemplate_form_rosterTemplateNameLabel"
                                      ),
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.RosterTemplateData.roster_weekly_template_name =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "4",
                                    lg: "4",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_ClaimReason_form_codeLabel"
                                      ),
                                      maxlength: "100",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules", "_Length_Rules"],
                                        [null, 100]
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.RosterTemplateData
                                          .roster_weekly_template_code,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.RosterTemplateData,
                                          "roster_weekly_template_code",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "RosterTemplateData.roster_weekly_template_code",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                  },
                                },
                                [
                                  _c("inputTextFiledMultiLang", {
                                    attrs: {
                                      maxlength: "500",
                                      bindData:
                                        _vm.RosterTemplateData
                                          .roster_weekly_template_description,
                                      label: _vm.$t(
                                        "label_essweb_RosterTemplate_form_rosterTemplateDescriptionLabel"
                                      ),
                                    },
                                    on: {
                                      change: function (valueArr) {
                                        _vm.RosterTemplateData.roster_weekly_template_description =
                                          valueArr
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                  },
                                },
                                [
                                  _c("DateTimePicker", {
                                    attrs: {
                                      type: "date",
                                      label: _vm.$t(
                                        "label_essweb_RosterFormRecord_list_startDateLabel"
                                      ),
                                      defaultTime:
                                        _vm.RosterTemplateData
                                          .start_utc_datetime,
                                      placeholder: "YYYY/MM/DD",
                                      rules: _vm.$GetRules(
                                        ["_Require_Rules"],
                                        [null]
                                      ),
                                    },
                                    on: {
                                      change: function (time) {
                                        _vm.RosterTemplateData.start_utc_datetime =
                                          time
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      type: "number",
                                      maxlength: "11",
                                      rules: _vm.$GetRules(
                                        ["_Number_negative", "_Length_Rules"],
                                        [null, 11]
                                      ),
                                      label: _vm.$t(
                                        "label_essweb_RosterTemplate_form_stdWorkMinutesLabel"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.RosterTemplateData.std_work_integer,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.RosterTemplateData,
                                          "std_work_integer",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "RosterTemplateData.std_work_integer",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "6",
                                    md: "6",
                                    lg: "6",
                                  },
                                },
                                [
                                  _c("normalInputTextFiled", {
                                    attrs: {
                                      maxlength: "100",
                                      readonly: "",
                                      label: _vm.$t(
                                        "label_essweb_RosterTemplate_form_stdWorkTimeLabel"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.RosterTemplateData.std_work_text,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.RosterTemplateData,
                                          "std_work_text",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "RosterTemplateData.std_work_text",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                  },
                                },
                                [
                                  _c(
                                    "v-sheet",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "label_essweb_RosterTemplate_form_remarkLabel"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("v-textarea", {
                                    attrs: {
                                      rows: "5",
                                      "no-resize": "",
                                      maxlength: "500",
                                      dense: "",
                                      filled: "",
                                      counter: "500",
                                      "single-line": "",
                                      name: "input-7-4",
                                    },
                                    model: {
                                      value: _vm.RosterTemplateData.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.RosterTemplateData,
                                          "remarks",
                                          $$v
                                        )
                                      },
                                      expression: "RosterTemplateData.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-3",
                                  attrs: {
                                    xs: "12",
                                    sm: "12",
                                    md: "12",
                                    lg: "12",
                                    cols: "12",
                                  },
                                },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label: _vm.$t(
                                        "label_essweb_RosterTemplate_form_setAsDefault"
                                      ),
                                      color: "primary",
                                      required: "",
                                    },
                                    model: {
                                      value: _vm.RosterTemplateData.is_default,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.RosterTemplateData,
                                          "is_default",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "RosterTemplateData.is_default",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.desserts,
                          avPerPage: 20,
                          showSelect: _vm.showSelect,
                          showFooter: false,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "top",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "mx-auto" },
                                  [
                                    _c(
                                      "v-form",
                                      {
                                        ref: "form2",
                                        attrs: { "lazy-validation": "" },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                attrs: {
                                                  xs: "12",
                                                  sm: "12",
                                                  md: "12",
                                                  lg: "12",
                                                  cols: "12",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-sheet",
                                                  {
                                                    staticClass:
                                                      "mrc_text_require text--secondary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_RosterTemplate_form_cycleTypeLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c("v-select", {
                                                  attrs: {
                                                    items: _vm.CycleTypeList,
                                                    dense: "",
                                                    filled: "",
                                                    "item-value": "value_field",
                                                    "item-text": "view_fields",
                                                    "hide-details": "",
                                                    "menu-props": {
                                                      offsetY: true,
                                                      transition:
                                                        "slide-y-transition",
                                                      rounded: true,
                                                      contentClass:
                                                        "elevation-4",
                                                    },
                                                    placeholder: _vm.$t(
                                                      "label_essweb_RosterTemplate_form_cycleTypeLabel"
                                                    ),
                                                    rules: _vm.$GetRules(
                                                      ["_Require_Rules"],
                                                      [null]
                                                    ),
                                                    "single-line": "",
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "no-data",
                                                      fn: function () {
                                                        return [_c("noContent")]
                                                      },
                                                      proxy: true,
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function (data) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getCommonLangValue(
                                                                  data.item
                                                                    .view_fields
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                    {
                                                      key: "item",
                                                      fn: function (data) {
                                                        return [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getCommonLangValue(
                                                                  data.item
                                                                    .view_fields
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ]),
                                                  model: {
                                                    value: _vm.curCycleType,
                                                    callback: function ($$v) {
                                                      _vm.curCycleType = $$v
                                                    },
                                                    expression: "curCycleType",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "item.sequence",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.curCycleType
                                            ? _vm.$getCommonLangValue(
                                                _vm.curWeek[
                                                  Number(item.sequence)
                                                ].view_fields
                                              )
                                            : item.sequence
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.name",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "table-title text--primary",
                                    attrs: {
                                      title: item.shift
                                        ? _vm.$getCommonLangValue(
                                            item.shift.shift_name
                                          ) +
                                          "(" +
                                          _vm.$timeMachine(
                                            item.shift.start_utc_time
                                          ) +
                                          " - " +
                                          _vm.$timeMachine(
                                            item.shift.end_utc_time
                                          ) +
                                          ")"
                                        : "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.shift
                                            ? _vm.$getCommonLangValue(
                                                item.shift.shift_name
                                              ) +
                                                "(" +
                                                _vm.$timeMachine(
                                                  item.shift.start_utc_time
                                                ) +
                                                " - " +
                                                _vm.$timeMachine(
                                                  item.shift.end_utc_time
                                                ) +
                                                ")"
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toEditProperty(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons-round" },
                                      [_vm._v("add")]
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                newBtn:
                  _vm.stepper.length == _vm.curStep && _vm.curStep != 0
                    ? true
                    : false,
                step: _vm.stepper.length == _vm.curStep ? false : true,
                preStep: _vm.curStep > 1 ? true : false,
              },
              on: {
                next: _vm.toNext,
                pre: function ($event) {
                  _vm.curStep = _vm.curStep - 1
                },
                new: _vm.toNew,
                cancel: function ($event) {
                  return _vm.$toBack(_vm.isChanged)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("normalDialog", {
              attrs: {
                deleteModel: "",
                dialog: _vm.showPGDelete,
                title: "Event Property Group",
              },
              on: {
                close: function ($event) {
                  _vm.showPGDelete = false
                },
                confirm: _vm.toDeletePG,
              },
            }),
            _c("editRosterTemplateDialog", {
              attrs: { show: _vm.showEditDialog, curProperty: _vm.curProperty },
              on: {
                onEdit: _vm.onEditProperty,
                close: function ($event) {
                  _vm.showEditDialog = false
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }